<script setup lang="ts">
console.log("hello world")
</script>

<template>
<h1>Hello from offboarding survey JS component</h1>
</template>

<style scoped>

</style>
